(function () {
  function initReveal() {
    var els = document.querySelectorAll('.ne-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('ne-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('ne-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGallery() {
    document.querySelectorAll('[data-ne-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-ne-main]');
      var thumbs = g.querySelectorAll('[data-ne-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 120);
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-ne-sticky]');
    var target = document.querySelector('[data-ne-buy]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    });
    io.observe(target);
  }

  function initSwatches() {
    document.querySelectorAll('[data-ne-swatches]').forEach(function (box) {
      var form = box.closest('form');
      var idInput = form && form.querySelector('input[name=id]');
      var name = box.querySelector('[data-ne-swatch-name]');
      var sw = box.querySelectorAll('[data-ne-swatch]');
      sw.forEach(function (b) {
        b.addEventListener('click', function () {
          sw.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          if (idInput) idInput.value = b.getAttribute('data-variant-id');
          if (name) name.textContent = b.getAttribute('data-name');
          var src = b.getAttribute('data-image');
          var main = document.querySelector('[data-ne-main]');
          if (src && main) { main.style.opacity = 0; setTimeout(function () { main.src = src; main.style.opacity = 1; }, 120);
            document.querySelectorAll('[data-ne-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-src') === src); }); }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initGallery(); initSticky(); initSwatches();
  });
})();
